export default __webpack_public_path__ + "static/media/cookie.d6835687.md";